export default __webpack_public_path__ + "static/media/tink.d5ffaf9a.ogg";